export default {
  slots: {
    error: 'mt-1 text-[0.85rem]',
    label: 'text-nowrap text-gray-900 dark:text-gray-100 mb-[1px] -mt-[1px] text-sm font-medium',
    help: 'text-xs mt-1 pb-1',
  },
}